import { IconProps } from 'types';

const ChevronRight = ({ className, title }: IconProps) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        width={24}
        height={24}
        fill="none"
    >
        <title>{title}</title>
        <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export default ChevronRight;
